<!--临时客商新增  -->
<template>
	<div class="info-box">
		<el-dialog
			title="客商信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			top="3vh"
			:before-close="cancle">
			<div class="info-title">基础信息:</div>

			<!--  -->
			<div class="form-box mt15">
				<el-form label-position="right" :inline="true" size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
					<el-form-item label="客商编号" prop="agentCode" v-show="rowData.agentId">
						<el-input v-model.trim="ruleForm.agentCode" class="w190" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="组织部门">
						<el-input v-model.trim="ruleForm.groupName" class="w190" :disabled="true"></el-input>
					</el-form-item>

					<el-form-item label="销售范围" prop="skuIds">
						<el-select v-model="ruleForm.skuIds" multiple class="w190" size="small" placeholder="选择">
							<el-option v-for="item in skuList" :key="item.skuId" :label="item.skuName" :value="item.skuId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客商名称" prop="agentName">
						<el-input v-model.trim="ruleForm.agentName" class="w190" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="客商简称">
						<el-input v-model.trim="ruleForm.agentShortName" class="w190" maxlength="15"></el-input>
					</el-form-item>
					<div class="w420 fl">
						<div class="flex flex-between">
							<el-form-item label="结算方式" prop="settlementType">
								<el-select v-model="ruleForm.settlementType" class="w90" size="small" placeholder="选择" :disabled="true">
									<el-option label="现金" value="0"></el-option>
									<el-option label="账期" value="1"></el-option>
									<el-option label="自贩" value="9"></el-option>
									<el-option label="其它" value="2"></el-option>
								</el-select>
								<el-select
									v-if="ruleForm.settlementType == '9'"
									v-model="ruleForm.priceId"
									class="auto-price-select"
									size="small"
									placeholder="选择"
									disabled>
									<el-option v-for="item in autoPriceList" :key="item.priceId" :label="item.priceName" :value="item.priceId"></el-option>
								</el-select>
								<el-checkbox v-if="rowData.ncCode && ruleForm.settlementType != '9'" class="ml10" v-model="ruleForm.advancesFlag" disabled>
									是否预付款
								</el-checkbox>
							</el-form-item>
						</div>
					</div>

					<el-form-item label="特渠">
						<el-select v-model="ruleForm.specialChannel" class="w190" size="small" placeholder="选择">
							<el-option v-for="item in codeList" :key="item.codesetId" :label="item.itemName" :value="item.codesetId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="联系人" prop="contacts">
						<el-input v-model.trim="ruleForm.contacts" class="w190" maxlength="8"></el-input>
					</el-form-item>
					<el-form-item label="销售据点分类">
						<el-select v-model="ruleForm.agentTag1" class="w190" size="small" placeholder="选择">
							<el-option label="分公司" value="分公司"></el-option>
							<el-option label="外仓" value="外仓"></el-option>
							<el-option label="营业所" value="营业所"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="联系手机" prop="contactsPhone">
						<el-input v-model.trim="ruleForm.contactsPhone" class="w190" maxlength="15"></el-input>
					</el-form-item>
					<el-form-item label="养乐多担当">
						<el-input v-model.trim="ruleForm.agentResponsibler" class="w190" maxlength="16"></el-input>
					</el-form-item>

					<el-form-item label="客商标签3">
						<el-autocomplete
							class="w190"
							:maxlength="10"
							v-model="ruleForm.agentTag3"
							:fetch-suggestions="querySearch"
							placeholder="请输入内容"></el-autocomplete>
					</el-form-item>
					<el-form-item label="详细地址">
						<el-input v-model.trim="ruleForm.address" class="w190" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="SAP封存日期">
						<el-input v-model.trim="ruleForm.ncSealflag" disabled class="w190" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="同步更新时间">
						<el-input v-model.trim="ruleForm.updatedTime" disabled class="w190" maxlength="20"></el-input>
					</el-form-item>
					<div v-show="rowData.agentId">
						<div class="info-title">SAP信息:</div>
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">SAP编码:</span>
									<span class="ml15">{{ sapInfo.sapNo || "无" }}</span>
								</div>
							</div>
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">系列:</span>
									<span class="ml15">{{ sapInfo.serialName || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">子系列:</span>
									<span class="ml15">{{ sapInfo.subSerialName || "无" }}</span>
								</div>
							</div>
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">配送方式:</span>
									<span class="ml15">{{ sapInfo.deliveryCode || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">客商归属:</span>
									<span class="ml15">{{ sapInfo.ownerCode || "无" }}</span>
								</div>
							</div>
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">大区:</span>
									<span class="ml15">{{ sapInfo.superAreaName || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">地区:</span>
									<span class="ml15">{{ sapInfo.areaName || "无" }}</span>
								</div>
							</div>
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">渠道:</span>
									<span class="ml15">{{ sapInfo.channelName || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">渠道细分:</span>
									<span class="ml15">{{ sapInfo.channelItemName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">分销渠道:</span>
									<span class="ml15">{{ sapInfo.salesChannelName || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">交货工厂:</span>
									<span class="ml15">{{ sapInfo.factoryName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">销售组织编码:</span>
									<span class="ml15">{{ sapInfo.salesOrgCode || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">销售组织名称:</span>
									<span class="ml15">{{ sapInfo.salesOrgName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">送达方编号:</span>
									<span class="ml15">{{ sapInfo.consigneeNo || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">送达方名称:</span>
									<span class="ml15">{{ sapInfo.consigneeName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">开票方编号:</span>
									<span class="ml15">{{ sapInfo.drawerNo || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">开票方名称:</span>
									<span class="ml15">{{ sapInfo.drawerName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">付款方编号:</span>
									<span class="ml15">{{ sapInfo.payerNo || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">付款方名称:</span>
									<span class="ml15">{{ sapInfo.payerName || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">银行账户:</span>
									<span class="ml15">{{ sapInfo.bankAccount || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">增值税号:</span>
									<span class="ml15">{{ sapInfo.taxpayerNo || "无" }}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">付款条件(财务):</span>
									<span class="ml15">{{ sapInfo.payConditionName || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">付款条件(销售)：</span>
									<span class="ml15">{{ sapInfo.payConditionNameSale || "无" }}</span>
								</div>
							</div>
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name">币种:</span>
									<span class="ml15">{{ sapInfo.currency || "无" }}</span>
								</div>
								<div class="flex-1">
									<span class="info-name">信贷限额:</span>
									<span class="ml15">{{ sapInfo.creditLimit || "无" }}</span>
								</div>
							</div>
							
						</div>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { dateTimeFormat } from "@/utils/common";
export default {
	components: {},
	data() {
		return {
			dialogVisible: false,
			groupDate: [],
			ruleForm: {
				groupId: "",
				agentName: "",
				ncSealflag: "",
				agentShortName: "",
				settlementType: "",
				advancesFlag: "",
				skuIds: [],
				specialChannel: "",
				contacts: "",
				address: "",
				agentTag1: "",
				agentTag2: "",
				agentTag3: "",
				agentCode: "",
				ncChannelName: "",
				channelMince: "",
				ncAreaCode: "",
				contactsPhone: "",
				agentArea: "",
				updatedTime: "",
				agentResponsibler: "",
				priceId: "",
			},
			rules: {
				agentName: [
					{
						required: true,
						message: "请输入客商名称",
						trigger: "blur",
					},
				],
				settlementType: [
					{
						required: true,
						message: "请选择结算方式",
						trigger: "change",
					},
				],
				skuIds: [
					{
						type: "array",
						required: true,
						message: "请选择销售范围",
						trigger: "change",
					},
				],
				contacts: [
					{
						pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,8}?$/,
						message: "请输入8位以内汉字、英文",
					},
				],
				contactsPhone: [
					{
						pattern: /^[0-9-]{1,15}?$/,
						message: "请输入15位以内数字中划线",
					},
				],
			},
			skuList: [],
			rowData: {},
			codeList: [],
			// 渠道细分列表
			codeDetailList: [],
			agentTagList: [],
			sapInfo: {},
			// 自贩机价格列表
			autoPriceList: [],
		};
	},
	created() {},
	methods: {
		init(data) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				console.log(data);
				this.$refs["ruleForm"].resetFields();
				this.agentTagList = [];
				this.rowData = {};
				this.codeDetailList = [];
				this.getSkuList(data.settlementType);
				this.getCodeList();
				// 自贩机价格列表
				if (data.settlementType == "9") {
					this.getAutoPriceList();
				}
				this.ruleForm = {
					groupId: "",
					agentName: "",
					agentShortName: "",
					settlementType: "",
					advancesFlag: "",
					skuIds: [],
					specialChannel: "",
					contacts: "",
					address: "",
					agentTag1: "",
					agentTag2: "",
					ncSealflag: "",
					agentTag3: "",
					agentCode: "",
					ncChannelName: "",
					channelMince: "",
					ncAreaCode: "",
					contactsPhone: "",
					updatedTime: "",
					agentResponsibler: "",
					priceId: "",
				};
				if (data) {
					this.rowData = data;
					let skuIds = data.skuIds ? data.skuIds.split(",") : [];
					let arr = [];
					skuIds.forEach((item) => {
						arr.push(parseInt(item));
					});
					this.ruleForm = {
						groupId: data.groupId,
						agentName: data.agentName,
						agentShortName: data.agentShortName,
						settlementType: data.settlementType,
						advancesFlag: data.advancesFlag == "Y" ? true : false,
						skuIds: arr,
						specialChannel: data.specialChannel ? parseInt(data.specialChannel) : "",
						contacts: data.contacts,
						address: data.address,
						ncSealflag: data.ncSealflag,
						agentTag1: data.agentTag1,
						agentTag2: data.agentTag2,
						agentTag3: data.agentTag3,
						agentCode: data.agentCode,
						groupName: data.groupName,
						ncChannelName: data.ncChannelName,
						channelMince: data.channelMince ? Number(data.channelMince) : "",
						ncAreaCode: data.ncAreaCode,
						contactsPhone: data.contactsPhone,
						agentArea: data.agentArea,
						updatedTime: data.updatedTime ? dateTimeFormat(data.updatedTime) : "",
						agentResponsibler: data.agentResponsibler,
						priceId: data.priceId,
					};
					data.ncChannel ? this.getCodeDetailList(data.ncChannel) : "";
					this.getAgentTags();
					this.getAgentInfoSap();
				}
			});
		},
		// 获取自贩机价格
		getAutoPriceList() {
			// 获取价格列表
			this.$request
				.post("getPriceList", true, {
					priceType: 1,
					settlementType: "9",
				})
				.then((res) => {
					if (res) {
						this.autoPriceList = res.data;
					}
				});
		},
		//  客商标签获取
		getAgentTags() {
			let that = this;
			that.$request
				.post("getAgentTags", false, {
					groupId: that.ruleForm.groupId,
				})
				.then((res) => {
					if (res) {
						that.agentTagList = [];
						res.data.forEach((item) => {
							that.agentTagList.push({
								value: item,
							});
						});
					}
				});
		},
		querySearch(queryString, cb) {
			// 调用 callback 返回建议列表的数据
			cb(this.agentTagList);
		},
		// 组织结构处理
		handleGroup() {
			this.ruleForm.agentTag1 = "";
			this.ruleForm.agentTag2 = "";
			this.ruleForm.agentTag3 = "";
			this.getAgentTags();
		},
		//  sku获取
		getSkuList(settlementType) {
			let that = this;
			that.$request
				.post("skuList", false, {
					userStatus: 0,
					settlementType: settlementType,
				})
				.then((res) => {
					if (res) {
						that.skuList = res.data;
					}
				});
		},
		//  特渠获取
		getCodeList() {
			let that = this;
			that.$request
				.post("agentCodeList", false, {
					codesetCode: "SP_CHANNEL",
				})
				.then((res) => {
					if (res) {
						that.codeList = res.data;
					}
				});
		},
		//  渠道细分
		getCodeDetailList(itemCode) {
			let that = this;
			that.$request
				.post("getCodeDetailList", false, {
					codesetCode: "NC_CHANNEL",
					itemCode: itemCode,
				})
				.then((res) => {
					if (res) {
						that.codeDetailList = res.data;
					}
				});
		},

		// 保存
		submitForm: debounce(
			function () {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.$confirm("是否确认保存？", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
						})
							.then(() => {
								this.updateRow();
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true,
		),
		// 修改
		updateRow() {
			let that = this;
			that.$request
				.post("agentUpdate", false, {
					agentId: that.rowData.agentId,
					groupId: that.ruleForm.groupId,
					agentName: that.ruleForm.agentName,
					agentShortName: that.ruleForm.agentShortName,
					settlementType: that.ruleForm.settlementType,
					advancesFlag: that.ruleForm.advancesFlag ? "Y" : "N",
					skuIds: that.ruleForm.skuIds.join(","),
					specialChannel: that.ruleForm.specialChannel,
					contacts: that.ruleForm.contacts,
					address: that.ruleForm.address,
					agentTag1: that.ruleForm.agentTag1,
					agentTag2: that.ruleForm.agentTag2,
					agentTag3: that.ruleForm.agentTag3,
					channelMince: that.ruleForm.channelMince,
					ncAreaCode: that.ruleForm.ncAreaCode,
					contactsPhone: that.ruleForm.contactsPhone,
					agentArea: that.ruleForm.agentArea,
					priceId: that.ruleForm.priceId,
				})
				.then((res) => {
					if (res) {
						that.dialogVisible = false;
						that.$message.success("保存成功！");
						that.$emit("getList");
					}
				});
		},
		// 取消
		cancle() {
			this.$nextTick(() => {
				this.$refs["ruleForm"].resetFields();
			});
			this.dialogVisible = false;
		},
		// 获取SAP信息
		getAgentInfoSap() {
			let that = this;
			that.$request
				.post("agentInfoSap", false, {
					sapNo: that.rowData.sapNo || "",
				})
				.then((res) => {
					if (res.code == 0) {
						that.sapInfo = res.data || {};
					}
				});
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}

.w90 {
	width: 110px;
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}

.mb10 {
	margin-bottom: 10px !important;
}

.w190 {
	width: 280px !important;
}

.info-box {
	/deep/ .el-dialog__body {
		// height: 350px;
		padding: 20px 20px 10px;
		overflow-y: auto;
	}
}

.info-title {
	background: #e5e5e5;
	color: #333;
	padding: 10px;
	box-sizing: border-box;
	font-size: 16px;
	font-weight: bold;
}

.el-form-item {
	width: 420px;
}

.w330 {
	width: 330px;
}

.w420 {
	width: 420px !important;
	margin-right: 10px;
}

.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
	color: #999;
}
.auto-price-select {
	width: 160px;
	margin-left: 10px;
}
</style>
